module.exports = __webpack_public_path__ + "b8283bb4ee5e5a51f9ed7ff2d5100021.pdf";